const tabList = (value, i) => ({
  marginLeft: '20px',
  marginRight: '20px',
  fontWeight: 'bold',
  color: value === i ? '#32bbff' : '#000',
  textTransform: 'none',
  fontFamily: 'metropolis',
});

export default tabList;
